import { Instance } from 'mobx-state-tree';
import { VisitLatLngDtoModelBase } from './VisitLatLngDtoModel.base';

/* The TypeScript type of an instance of VisitLatLngDtoModel */
export interface VisitLatLngDtoModelType extends Instance<typeof VisitLatLngDtoModel.Type> {}

/* A graphql query fragment builders for VisitLatLngDtoModel */
export { selectFromVisitLatLngDto, visitLatLngDtoModelPrimitives, VisitLatLngDtoModelSelector } from './VisitLatLngDtoModel.base';

/**
 * VisitLatLngDtoModel
 */
export const VisitLatLngDtoModel = VisitLatLngDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
